import inventoryAPI from '@/services/api/inventory2'
import categoryAPI from '@/services/api/inventory/category'
import _ from 'lodash'
import cookies from 'vue-cookies'

const state = {
	list: null,
	count: null,
	loadParams: {
		keyword: '',
		groupsId: [],
		offset: 0,
		length: 50,
		order: ['CREATE_DATETIME'],
		orderDirection: ['DESC'],
		status: JSON.parse(cookies.get('filter_inventory_status')) || [],
		categoriesId:
			JSON.parse(cookies.get('filter_inventory_categoriesId')) || [],
		categoriesClassification:
			JSON.parse(
				cookies.get('filter_inventory_categoriesClassification')
			) || [],
		registerMethods:
			JSON.parse(cookies.get('filter_inventory_registerMethods')) || [],
		brandsId: JSON.parse(cookies.get('filter_inventory_brandsId')) || [],
		storagesId:
			JSON.parse(cookies.get('filter_inventory_storagesId')) || [],
		legalsId: JSON.parse(cookies.get('filter_inventory_legalsId')) || [],
		currentVolume:
			JSON.parse(cookies.get('filter_inventory_currentVolume')) || [],
		threshold: JSON.parse(cookies.get('filter_inventory_threshold')) || [],
		expireDate:
			JSON.parse(cookies.get('filter_inventory_expireDate')) || [],
		qrBarcode: '',
		isFavorite: false,
	},
	filter: null,
	filterCookieName: {
		status: 'filter_inventory_status',
		categoriesId: 'filter_inventory_categoriesId',
		registerMethods: 'filter_inventory_registerMethods',
		storagesId: 'filter_inventory_storagesId',
		brandsId: 'filter_inventory_brandsId',
		legalsId: 'filter_inventory_legalsId',
		currentVolume: 'filter_inventory_currentVolume',
		threshold: 'filter_inventory_threshold',
		expireDate: 'filter_inventory_expireDate',
	},
	isFold: true,
	categoryList: [],
}

const getters = {
	selectedCategoriesClassification: state =>
		state.loadParams.categoriesClassification.length != 1
			? 'ALL'
			: state.loadParams.categoriesClassification[0],
	list: state => state.list,
	count: state => state.count,
	keyword: state => state.loadParams.keyword,
	qrBarcode: state => state.loadParams.qrBarcode,
	isEmptyList: state => state.count === 0,
	filterCookieName: state => state.filterCookieName,
	filteredCount: state =>
		state.loadParams.status.length +
		state.loadParams.categoriesId.length +
		state.loadParams.brandsId.length +
		state.loadParams.registerMethods.length +
		state.loadParams.storagesId.length +
		state.loadParams.legalsId.length +
		state.loadParams.threshold.length +
		state.loadParams.currentVolume.length +
		state.loadParams.expireDate.length,
	filteredList: state => {
		return {
			status: state.loadParams.status,
			categoriesId: state.loadParams.categoriesId,
			brandsId: state.loadParams.brandsId,
			registerMethods: state.loadParams.registerMethods,
			storagesId: state.loadParams.storagesId,
			legalsId: state.loadParams.legalsId,
			currentVolume: state.loadParams.currentVolume,
			threshold: state.loadParams.threshold,
			expireDate: state.loadParams.expireDate,
		}
	},
	order: state => state.loadParams.order[0],
	orderDirection: state => state.loadParams.orderDirection[0],
	isFold: state => state.isFold,
	categoryList: state => {
		let classification = null
		if (state.loadParams.categoriesClassification.length > 0) {
			classification = state.loadParams.categoriesClassification[0]
		}
		return state.categoryList.filter(
			it => classification == null || it.classification == classification
		)
	},
	isFavorite: state => state.loadParams.isFavorite,
}

const mutations = {
	setInventoryList: (state, inventoryList) => {
		state.list = state.list.concat(inventoryList.list)
		state.count = inventoryList.count
		state.loadParams.offset = state.list.length
	},
	setLoadParams: (state, loadParams) => {
		if (loadParams != null)
			Object.keys(loadParams).forEach(key => {
				state.loadParams[key] = loadParams[key]
			})
	},
	setFilter: (state, data) => {
		state.filter = data
	},
	initOffset: state => {
		state.loadParams.offset = 0
		state.list = []
	},
	setFold: (state, fold) => {
		state.isFold = fold
	},
	setCategoryList: (state, list) => {
		state.categoryList = list
	},
	initFilterCookies: (state, needReset) => {
		if (needReset)
			Object.values(state.filterCookieName).forEach(key => {
				cookies.set(key, JSON.stringify([]))
			})
		state.loadParams = {
			offset: 0,
			length: 50,
			order: ['CREATE_DATETIME'],
			orderDirection: ['DESC'],
			keyword: '',
			status: JSON.parse(cookies.get(`filter_inventory_status`)) || [],
			categoriesId:
				JSON.parse(cookies.get(`filter_inventory_categoriesId`)) || [],
			categoriesClassification: [],
			registerMethods:
				JSON.parse(cookies.get(`filter_inventory_registerMethods`)) ||
				[],
			brandsId:
				JSON.parse(cookies.get(`filter_inventory_brandsId`)) || [],
			storagesId:
				JSON.parse(cookies.get(`filter_inventory_storagesId`)) || [],
			legalsId:
				JSON.parse(cookies.get(`filter_inventory_legalsId`)) || [],
			currentVolume:
				JSON.parse(cookies.get(`filter_inventory_currentVolume`)) || [],
			threshold:
				JSON.parse(cookies.get(`filter_inventory_threshold`)) || [],
			expireDate:
				JSON.parse(cookies.get(`filter_inventory_expireDate`)) || [],
			qrSticker: '',
			qrBarcode: '',
			productCode: '',
			groupsId: [],
			isFavorite: false,
		}
	},
	setKeywordOfTag: (state, keyword) => {
		state.loadParams.keyword = keyword
	},
}

const actions = {
	getList: async ({ commit, rootGetters, state }, isMore = false) => {
		if (!isMore) commit('initOffset')
		const response = await inventoryAPI.getList(
			rootGetters.instituteId,
			state.loadParams
		)
		commit('setInventoryList', response.data)
	},
	divideInventoryItem: async ({ dispatch, rootGetters }, body) => {
		await inventoryAPI.divideInventoryItem(rootGetters.instituteId, body)
		dispatch('getList')
	},
	deleteInventoryItem: async (
		{ commit, dispatch, rootGetters, getters },
		ids
	) => {
		await inventoryAPI.deleteInventoryItem(rootGetters.instituteId, {
			ids: ids ? ids : getters.selectItemId,
		})
		if (!ids) {
			commit('setSelectItem', [])
		}
		dispatch('getList')
	},
	setLoadParams: async ({ commit, dispatch }, loadParams) => {
		commit('setLoadParams', loadParams)
		return dispatch('getList')
	},
	getFilter: async ({ commit, rootGetters, state }) => {
		const response = await inventoryAPI.getFilter(rootGetters.instituteId, {
			categoriesClassification: state.loadParams.categoriesClassification,
		})
		commit('setFilter', response.data)
	},
	getItemCount: async ({ state, rootGetters }, filterPararms) => {
		const response = await inventoryAPI.getList(rootGetters.instituteId, {
			...filterPararms,
			categoriesClassification: state.loadParams.categoriesClassification,
		})
		return response.data.count
	},
	getCategoryList: async ({ commit, rootGetters }) => {
		const response = await categoryAPI.lookupCategoryList(
			rootGetters.instituteId
		)
		commit('setCategoryList', response.data)
	},
	exportExcel: async ({ state, rootGetters }, type) => {
		const response = await inventoryAPI.exportExcel(
			rootGetters.instituteId,
			type == 'ALL' ? null : state.loadParams
		)
		return response
	},
	getTagList: async ({ state, rootGetters }, isAll = false) => {
		let keyword = state.loadParams.keyword
		if (keyword.length > 0 && keyword[0] == '#') {
			keyword = keyword.slice(1)
		}
		const response = await inventoryAPI.tagList(rootGetters.instituteId, {
			keyword: keyword,
			offset: 0,
			length: 1000,
		})
		return response
	},
	addFavorite: async ({ rootGetters }, id) => {
		await inventoryAPI.addFavorite(rootGetters.instituteId, {
			inventoryId: id,
		})
	},
	deleteFavorite: async ({ rootGetters }, id) => {
		await inventoryAPI.deleteFavorite(rootGetters.instituteId, {
			inventoryId: id,
		})
	},
	getComment: async ({ rootGetters, commit }, type) => {
		const response = await inventoryAPI.getComment(
			rootGetters.instituteId,
			{ type: type }
		)
		return response.data
	},
	addComment: async ({ rootGetters }, body) => {
		await inventoryAPI.addComment(rootGetters.instituteId, body)
	},
	deleteComment: async ({ rootGetters }, id) => {
		await inventoryAPI.deleteComment(rootGetters.instituteId, { id: id })
	},
}
export default { namespaced: true, state, getters, mutations, actions }
